enum EEnvironmentVariables {
  VITE_ENV = 'VITE_ENV',
  VITE_CHATBOT_AGENT_ID = 'VITE_CHATBOT_AGENT_ID',
  VITE_CHATBOT_MARKETING_AGENT_ID = 'VITE_CHATBOT_MARKETING_AGENT_ID',
  VITE_CHATBOT_ADMIN_AGENT_ID = 'VITE_CHATBOT_ADMIN_AGENT_ID',
  VITE_PARTNER_SERVICE = 'VITE_PARTNER_SERVICE',
  VITE_CREATE_NEW_ORG_PARTNER_ID = 'VITE_CREATE_NEW_ORG_PARTNER_ID',
  VITE_STRIPE_PUBLIC_KEY = 'VITE_STRIPE_PUBLIC_KEY',
  VITE_OIDC_NAME = 'VITE_OIDC_NAME',
  VITE_VIRTUAL_GURUS_OIDC_END_SESSION_URL = 'VITE_VIRTUAL_GURUS_OIDC_END_SESSION_URL',
  VITE_VIRTUAL_GURUS_OIDC_REGISTER_URL = 'VITE_VIRTUAL_GURUS_OIDC_REGISTER_URL',
  VITE_IS_CAMPAIGNS_ENABLED = 'VITE_IS_CAMPAIGNS_ENABLED',
  VITE_IS_MULTIAGENT_ENABLED = 'VITE_IS_MULTIAGENT_ENABLED',
  VITE_IS_SCENARIOS_ENABLED = 'VITE_IS_SCENARIOS_ENABLED',
  VITE_SCENARIO_SERVICE = 'VITE_SCENARIO_SERVICE',
  VITE_SHOW_USER_ACCESS_CAPABILITIES = 'VITE_SHOW_USER_ACCESS_CAPABILITIES',
  VITE_GTM_CONTAINER_ID = 'VITE_GTM_CONTAINER_ID',
  VITE_PHONE_SERVICE_TOKEN = 'VITE_PHONE_SERVICE_TOKEN',
  VITE_ONBOARDING_STATUS = 'VITE_ONBOARDING_STATUS',
  VITE_IS_LIVE_TRANSFERS_ENABLED = 'VITE_IS_LIVE_TRANSFERS_ENABLED',
  VITE_IS_ESCALATIONS_UNDER_CONSTRUCTION = 'VITE_IS_ESCALATIONS_UNDER_CONSTRUCTION',
  VITE_IS_LIVE_TRANSFERS_MIGRATION_COMPLETE = 'VITE_IS_LIVE_TRANSFERS_MIGRATION_COMPLETE',
  VITE_ENABLE_OFU_CAMPAIGNS = 'VITE_ENABLE_OFU_CAMPAIGNS',
  VITE_AGENT_SERVICE = 'VITE_AGENT_SERVICE',
  VITE_TEXT_SERVICE = 'VITE_TEXT_SERVICE',
  VITE_INTERNAL_API_SERVICE = 'VITE_INTERNAL_API_SERVICE',
  // VITE_VOIP_SERVICE = 'VITE_VOIP_SERVICE',
  VITE_EXTERNAL_SERVICE = 'VITE_EXTERNAL_SERVICE',
}

export default EEnvironmentVariables

// Vars whose OWN consuming code already treats "missing" as "feature off"
// (see useTurnstileToken's and useChatV2's own comments) rather than a hard
// requirement. Deliberately excluded from EEnvironmentVariables —
// checkEnvVars.ts treats every enum member as required with no per-var
// override, so a genuinely optional var has to live outside that enum
// entirely, not "in the enum but somehow marked optional" (there's no such
// mechanism today).
export enum EOptionalEnvironmentVariables {
  VITE_TURNSTILE_SITE_KEY = 'VITE_TURNSTILE_SITE_KEY',
  VITE_CHAT_V2_WS_URL = 'VITE_CHAT_V2_WS_URL',
  VITE_CHAT_V2_TOKEN_URL = 'VITE_CHAT_V2_TOKEN_URL',
  // Local-dev-only convenience: mirrors gateway-service's own
  // LOAD_TEST_BYPASS_SECRET (services/gateway-service/src/handlers/tokenRequest.ts)
  // — lets a locally-run frontend clear a real deployed backend's Turnstile
  // check (e.g. staging, whose site key is domain-locked and rejects
  // localhost) without touching that backend at all. Set only in a local,
  // never-committed .env. Its only consumer (useChatV2) gates the read on
  // import.meta.env.DEV, not on this being unset elsewhere — every VITE_ var
  // is baked into the bundle in ANY build mode, so a value accidentally set
  // in a shared build environment (CI/Amplify) must not reach shipped code
  // just because nobody meant to set it there.
  VITE_CHAT_V2_LOAD_TEST_BYPASS_SECRET = 'VITE_CHAT_V2_LOAD_TEST_BYPASS_SECRET',
  VITE_INTEGRATION_SYNC = 'VITE_INTEGRATION_SYNC',
}
